import { Box, Card, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const UpdatesEchallan = ({ eChallan }) => {
    const navigate = useNavigate()
    const handleBoxClick = (id: any) => {
        navigate(`/atom-pro/income-tax/e-challan/${id}`);
    };
    return (
        <>
             {eChallan && eChallan?.newItem && eChallan?.newItem?.length > 0 && (
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="h5" color={"primary"}>New e-Challans : {eChallan?.newItem?.length}</Typography>
                    </Grid>

                    {eChallan?.newItem?.map(item => (
                        <Grid item xs={4} key={item.id}>
                            <Card >
                                <Grid item sx={{ marginBottom: 1 }} onClick={() => handleBoxClick(item.id)} bgcolor={"#ffffff"} m={0.5} padding={0.5}>
                                    <Typography variant="body2"> <span style={{ fontWeight: "600", color: "#00264d" }}>Alternate CIN : </span> {item?.acin}</Typography>
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Assessment Year : </span> {item?.assmentYear}</Typography>
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Payment Time : </span> {moment(item?.paymentTime).format('MMM DD, YYYY')}</Typography>
                                    <Typography variant="body2" ><span style={{ fontWeight: "600", color: "#00264d" }}>Total Amount : </span> {item?.amount}</Typography>
                                </Grid>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
};

export default UpdatesEchallan;